import React, { useMemo } from "react";

import InitialDataListPage from "../components/InitialDataListPage";

const mapAccountType = (type) => {
  if (type === "SA") return "ออมทรัพย์";
  if (type === "CA") return "กระแสรายวัน";
  return type || "-";
};

const mapAparType = (value) => {
  if (value === "AP") return "เจ้าหนี้";
  if (value === "AR") return "ลูกหนี้";
  if (value === "CO") return "บริษัท";
  return value || "-";
};

const BankMain = ({
  masterList = [],
  name,
  onPageInsert,
  onRowSelected,
}) => {
  const columns = useMemo(
    () => [
      {
        key: "index",
        header: "#",
        width: "4%",
        align: "center",
        render: (_item, _index, { startIndex, itemIndex }) =>
          startIndex + itemIndex + 1,
      },
      {
        key: "Bank_Name_TH",
        header: "ชื่อบัญชี (ไทย)",
        width: "18%",
        align: "start",
        render: (item) => item.Bank_Name_TH || "-",
      },
      {
        key: "Bank_Name_EN",
        header: "ชื่อบัญชี (อังกฤษ)",
        width: "12%",
        align: "start",
        render: (item) => item.Bank_Name_EN || "-",
      },
      {
        key: "Bank_Account",
        header: "เลขที่บัญชี",
        width: "11%",
        align: "center",
        render: (item) => item.Bank_Account || "-",
      },
      {
        key: "Bank_Type",
        header: "ประเภทบัญชี",
        width: "7%",
        align: "center",
        render: (item) => mapAccountType(item.Bank_Type),
      },
      {
        key: "APAR_Type",
        header: "กลุ่มผู้ใช้",
        width: "7%",
        align: "center",
        render: (item) => mapAparType(item.APAR_Type),
      },
      {
        key: "CCode",
        header: "รหัสเจ้าของบัญชี",
        width: "9%",
        align: "center",
        render: (item) => item.CCode || "-",
      },
      {
        key: "NName",
        header: "ชื่อเจ้าของบัญชี",
        width: "11%",
        align: "start",
        render: (item) => item.NName || "-",
      },
      {
        key: "B_Name_TH",
        header: "ธนาคาร",
        width: "10%",
        align: "start",
        render: (item) => item.B_Name_TH || "-",
      },
      {
        key: "Bank_Status",
        header: "สถานะ",
        width: "6%",
        align: "center",
        render: (item) =>
          item.Bank_Status === "Y" ? "ใช้งาน" : "ไม่ใช้งาน",
      },
      {
        key: "actions",
        header: "แก้ไข",
        width: "5%",
        align: "center",
        isAction: true,
        render: (item, _index, { triggerRowSelected }) => (
          <button
            onClick={(event) => {
              event.stopPropagation();
              triggerRowSelected(item);
            }}
            className="btn btn-sm"
            title="แก้ไข"
            style={{
              width: "32px",
              height: "32px",
              borderRadius: "8px",
              border: "none",
              backgroundColor: "#fff3e0",
              color: "#EF6C00",
              transition: "all 0.2s ease",
            }}
            onMouseOver={(event) => {
              event.currentTarget.style.backgroundColor = "#EF6C00";
              event.currentTarget.style.color = "#fff";
            }}
            onMouseOut={(event) => {
              event.currentTarget.style.backgroundColor = "#fff3e0";
              event.currentTarget.style.color = "#EF6C00";
            }}
            type="button"
          >
            <i className="fas fa-edit" />
          </button>
        ),
      },
    ],
    []
  );

  const getSearchValues = useMemo(
    () => (item) => [
      item?.Bank_Name_TH,
      item?.Bank_Name_EN,
      item?.Bank_Account,
      mapAccountType(item?.Bank_Type),
      mapAparType(item?.APAR_Type),
      item?.CCode,
      item?.NName,
      item?.B_Name_TH,
      item?.Bank_Status === "Y" ? "ใช้งาน" : "ไม่ใช้งาน",
    ],
    []
  );

  return (
    <InitialDataListPage
      name={name}
      entityPath="/tbsetbank"
      data={masterList}
      onCreate={onPageInsert}
      onRowSelected={onRowSelected}
      columns={columns}
      getSearchValues={getSearchValues}
      searchPlaceholder={`ค้นหา${name || "ข้อมูลธนาคาร"}...`}
      fieldMappings={{ no: "Bank_Id" }}
      getRowId={(item) => item?.Bank_Id}
    />
  );
};

export default BankMain;
